export class ImgProcessingInteractiveModeEventArgs extends lt.LeadEventArgs {
  constructor(x: number, y: number) {
    super();

    this._x = x;
    this._y = y;
  }

  private _x: number;
  public get x(): number {
    return this._x;
  }
  private _y: number;
  public get y(): number {
    return this._y;
  }
}
